import { render, staticRenderFns } from "./CommentElement.vue?vue&type=template&id=3578615d&scoped=true&"
import script from "./CommentElement.vue?vue&type=script&lang=ts&"
export * from "./CommentElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578615d",
  null
  
)

export default component.exports